export default {
  type: "Feature",
  properties: { 
    name: "Алтай",
    location: [44.89866987434014, 95.75030312893907] },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [93.21740627288818, 44.99686891680278],
        [93.21195602416992, 45.00498626838617],
        [93.15032958984375, 45.24201954967743],
        [93.153076171875, 45.50057194157226],
        [93.13934326171875, 45.54867850352087],
        [93.10638427734375, 45.61403741135093],
        [93.0816650390625, 45.66780526567164],
        [93.0816650390625, 45.72535642341016],
        [93.12286376953124, 45.77135470445036],
        [93.24371337890625, 45.82114340079471],
        [93.37554931640625, 45.891919851282076],
        [93.40576171875, 46.044642082970135],
        [93.46618652343749, 46.17222297845542],
        [93.5430908203125, 46.24824991289166],
        [93.61724853515625, 46.36777895261494],
        [93.6309814453125, 46.41892578708076],
        [93.61175537109375, 46.479482189368646],
        [93.55133056640625, 46.5607488448596],
        [93.52111816406249, 46.632464724627475],
        [93.6199951171875, 46.62492015414768],
        [93.68865966796875, 46.59850587595948],
        [93.76556396484375, 46.549416608392264],
        [93.78204345703125, 46.579630646972596],
        [93.8287353515625, 46.621147474556096],
        [93.91937255859375, 46.70031853924921],
        [93.98529052734375, 46.72291755083757],
        [94.12261962890625, 46.72291755083757],
        [94.251708984375, 46.741742832123364],
        [94.405517578125, 46.800059446787316],
        [94.33959960937499, 46.832012719114765],
        [94.27093505859375, 46.89210855010365],
        [94.20501708984375, 46.99524110694596],
        [94.12261962890625, 47.10191431533551],
        [94.06494140625, 47.2270293988673],
        [94.04296874999999, 47.28295557691231],
        [93.9935302734375, 47.31648293428332],
        [93.8788604736328, 47.33603074146188],
        [93.77311706542969, 47.38998234483188],
        [93.74908447265625, 47.428087261714275],
        [93.70719909667969, 47.47127045275428],
        [93.63990783691406, 47.514418190183974],
        [93.53948593139648, 47.557472555826074],
        [93.61441612243652, 47.65161386351681],
        [93.6143946647644, 47.65159940883532],
        [93.65432739257812, 47.66538735632654],
        [93.88092041015625, 47.71530566159559],
        [94.0869140625, 47.76702233051035],
        [94.185791015625, 47.78548011929362],
        [94.23248291015625, 47.77809779004784],
        [94.3011474609375, 47.73932336136857],
        [94.47006225585938, 47.68388118858139],
        [94.67468261718749, 47.669086647137576],
        [94.7735595703125, 47.67648444221321],
        [94.97131347656249, 47.65613798222679],
        [95.01663208007812, 47.63948497925488],
        [95.0482177734375, 47.59690318115471],
        [95.0701904296875, 47.54223662718361],
        [95.24871826171875, 47.568187190520135],
        [95.53024291992188, 47.535746978239125],
        [95.59478759765624, 47.51349065484327],
        [95.75065612792967, 47.43319679984749],
        [95.80284118652344, 47.42669366522116],
        [95.91682434082031, 47.37789454155521],
        [95.98342895507812, 47.332773275955894],
        [96.02119445800781, 47.30949982141431],
        [96.05552673339844, 47.301584511330795],
        [96.10771179199219, 47.29739357321423],
        [96.15577697753905, 47.26804770458176],
        [96.19903564453125, 47.23402340128701],
        [96.23954772949219, 47.201376826785406],
        [96.26701354980469, 47.16637604771991],
        [96.2896728515625, 47.09116309620141],
        [96.28898620605467, 47.05702528260841],
        [96.28005981445312, 46.998987638154624],
        [96.29310607910156, 46.933385414813976],
        [96.30889892578125, 46.89163931213447],
        [96.34185791015625, 46.82731489926434],
        [96.40296936035156, 46.849860689868386],
        [96.49429321289062, 46.87662152939774],
        [96.52656555175781, 46.89163931213447],
        [96.59042358398438, 46.922131240914],
        [96.64535522460938, 46.933385414813976],
        [96.69342041015624, 46.92682076739938],
        [96.73049926757812, 46.90524554642923],
        [96.74972534179688, 46.86113003765812],
        [96.81976318359375, 46.79911935722295],
        [96.85684204101562, 46.74738913515841],
        [96.90078735351562, 46.70314393319737],
        [96.92413330078125, 46.65791988638765],
        [96.9378662109375, 46.60133659339023],
        [97.0257568359375, 46.586237724798856],
        [97.0751953125, 46.581518465658014],
        [97.13836669921874, 46.57679879569828],
        [97.18231201171875, 46.57868671298067],
        [97.2344970703125, 46.60039303734547],
        [97.34813690185547, 46.67559003496991],
        [97.39208221435547, 46.693254407491],
        [97.41302490234375, 46.66357496238209],
        [97.42538452148438, 46.64872912635656],
        [97.44152069091797, 46.63670808339624],
        [97.4593734741211, 46.62350543010974],
        [97.48374938964844, 46.61147878308617],
        [97.50640869140625, 46.60463891014406],
        [97.52906799316406, 46.600628927897176],
        [97.56769180297852, 46.597532782686486],
        [97.56752014160155, 46.59756227061819],
        [97.657470703125, 46.532413816559455],
        [97.745361328125, 46.27863122156088],
        [98.20678710937499, 45.98932892799953],
        [98.404541015625, 45.78284835197676],
        [98.470458984375, 45.43700828867389],
        [98.360595703125, 45.166547157856016],
        [98.184814453125, 44.91813929958515],
        [98.184814453125, 44.6061127451739],
        [98.10791015625, 44.449467536006935],
        [97.987060546875, 44.41024041296011],
        [97.91015624999999, 44.33956524809713],
        [97.93212890625, 44.07969327425713],
        [97.9541015625, 43.94537239244209],
        [97.91015624999999, 43.667871610117494],
        [97.8662109375, 43.50075243569041],
        [97.84423828125, 43.40504748787035],
        [97.745361328125, 43.28520334369384],
        [97.789306640625, 42.98857645832184],
        [97.789306640625, 42.70968691975666],
        [97.78947830200194, 42.70943464570875],
        [97.1630859375, 42.79540065303723],
        [96.99829101562499, 42.76314586689494],
        [96.383056640625, 42.72280375732727],
        [96.361083984375, 42.90816007196054],
        [95.877685546875, 43.24520272203356],
        [95.855712890625, 43.40504748787035],
        [95.51513671875, 44.01652134387754],
        [95.3173828125, 44.05601169578525],
        [95.361328125, 44.2294565683017],
        [95.4052734375, 44.29240108529005],
        [94.98779296875, 44.26093725039923],
        [94.7021484375, 44.33956524809713],
        [94.6142578125, 44.457309801319305],
        [94.427490234375, 44.535674532413196],
        [94.32861328125, 44.512176171071054],
        [94.32861328125, 44.574817404670306],
        [94.21875, 44.66865287227321],
        [93.702392578125, 44.84808025602074],
        [93.6968994140625, 44.89479576469787],
        [93.4991455078125, 44.96285457777543],
        [93.37554931640625, 44.984227835166486],
        [93.2904052734375, 44.984227835166486],
        [93.21736335754395, 44.9969144378685],
        [93.21740627288818, 44.99686891680278],
      ],
    ],
  },
};
